module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-down-right-24d58162.svg";